import { SET_FIELD_VALUE } from "../constants/fileConstant";

export const fieldValuesReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_FIELD_VALUE :
      return { ...state, [action.payload.key]: action.payload.value };
    default:
      return state;
  }
};